import styled from 'styled-components';

import { Row } from '@/components/Row';
import { theme } from '@/theme';

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-top: 40px;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormRow = styled(Row)`
  max-width: 880px;
  width: 100%;
  gap: 16px;

  ${theme.media.md.up} {
    width: 880px;
  }
`;

export const FieldRow = styled(Row)`
  max-width: 770px;
  width: 100%;
  gap: 16px;

  ${theme.media.md.up} {
    width: 770px;
  }
`;
